import React, { useEffect, useRef } from "react";

const DEFAULT_DURATION = 4000;

const LEFT_BORDER_ALERT = {
  primary: "alert-primary bg-primary-50 text-primary-600 border-primary-600",
  secondary: "alert-lilac bg-lilac-50 text-lilac-600 border-lilac-600",
  success: "alert-success bg-success-100 text-success-600 border-success-600",
  warning: "alert-warning bg-warning-100 text-warning-600 border-warning-600",
  info: "alert-info bg-info-100 text-info-600 border-info-600",
  danger: "alert-danger bg-danger-100 text-danger-600 border-danger-600",
  error: "alert-danger bg-danger-100 text-danger-600 border-danger-600",
};

const ALERT_ICON = {
  primary: "mingcute:emoji-line",
  secondary: "mingcute:emoji-line",
  success: "akar-icons:double-check",
  warning: "mdi:alert-circle-outline",
  info: "ci:link",
  danger: "mingcute:delete-2-line",
  error: "mingcute:delete-2-line",
};

const CLOSE_COLOR = {
  primary: "text-primary-600",
  secondary: "text-lilac-600",
  success: "text-success-600",
  warning: "text-warning-600",
  info: "text-info-600",
  danger: "text-danger-600",
  error: "text-danger-600",
};

export default function FlashMessage({
  type = "warning",
  message,
  onClose,
  duration = DEFAULT_DURATION,
  className = "",
}) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      if (onCloseRef.current) {
        onCloseRef.current();
      }
    }, duration);

    return () => window.clearTimeout(timer);
  }, [message, duration]);

  if (!message) {
    return null;
  }

  const variant = LEFT_BORDER_ALERT[type] || LEFT_BORDER_ALERT.warning;
  const icon = ALERT_ICON[type] || ALERT_ICON.warning;
  const closeColor = CLOSE_COLOR[type] || CLOSE_COLOR.warning;

  return (
    <div
      className={`alert ${variant} border-start-width-4-px border-top-0 border-end-0 border-bottom-0 px-24 py-13 mb-0 fw-semibold text-lg radius-4 d-flex align-items-center justify-content-between gap-2 agent-flash ${className}`.trim()}
      role="alert"
    >
      <div className="d-flex align-items-center gap-2 min-w-0 flex-grow-1">
        <iconify-icon icon={icon} className="icon text-xl flex-shrink-0"></iconify-icon>
        <div className="min-w-0">{message}</div>
      </div>
      {onClose ? (
        <button
          type="button"
          className={`remove-button ${closeColor} text-xxl line-height-1 agent-flash-close`}
          aria-label="Dismiss message"
          onClick={onClose}
        >
          <iconify-icon icon="iconamoon:sign-times-light" className="icon"></iconify-icon>
        </button>
      ) : null}
    </div>
  );
}
